import { GraduationCap, BookOpen, CreditCard } from "lucide-react";

import DataFetcherTemplateHome from "../../hooks/DataFetcherTemplateHome";
import BlockImageCabecera from "../../components/BlockImageCabecera";

const url =
  "https://be-ofertas.utpl.edu.ec/jsonapi/node/template_home/63e21e54-1471-4a50-bdee-f8cc6c5fed9c" +
  "?include=field_imagen_portada.field_media_image" +
  "&fields[node--template_home]=title,field_imagen_portada,field_texto_portada,field_bloque1,field_bloque2,field_bloque3" +
  "&fields[media--image]=field_media_image" +
  "&fields[file--file]=uri";

function SistemaAcademico() {
  const DataDisplay = ({ data }) => {
    const cards = [
      {
        icon: BookOpen,
        content: data.bloque1,
        iconBg: "bg-blue-50",
        iconColor: "text-[#004270]",
      },
      {
        icon: GraduationCap,
        content: data.bloque2,
         iconBg: "bg-blue-50",
        iconColor: "text-[#004270]",
      },
      {
        icon: CreditCard,
        content: data.bloque3,
          iconBg: "bg-blue-50",
        iconColor: "text-[#004270]",
      },
    ];

    return (
      <div className="w-full">
        {/* CABECERA */}
        <BlockImageCabecera
          src={data.imagen_portada}
          title={
            <div
              dangerouslySetInnerHTML={{
                __html: data.texto_portada,
              }}
            />
          }
        />

        {/* BLOQUES */}
        <section className="bg-slate-50 px-4 py-12 sm:px-6 lg:px-8 lg:py-16">
          <div className="mx-auto w-full max-w-6xl">
            <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
              {cards.map((card, index) => {
                const Icon = card.icon;

                return (
                  <article
                    key={index}
                    className="
                      flex h-full flex-col items-center
                      rounded-2xl bg-white p-6 text-center
                      shadow-lg shadow-slate-200/50
                      border border-slate-100
                    "
                  >
                    {/* ICONO */}
                    <div
                      className={`
                        flex h-16 w-16 shrink-0 items-center justify-center
                        rounded-2xl
                        ${card.iconBg}
                        ${card.iconColor}
                      `}
                    >
                      <Icon className="h-8 w-8" strokeWidth={1.8} />
                    </div>

                    {/* CONTENIDO */}
                    <div
                      className="
                        mt-5 w-full max-w-md
                        link-with-arrow-1                        
                        
                      "
                      dangerouslySetInnerHTML={{
                        __html: card.content,
                      }}
                    />
                  </article>
                );
              })}
            </div>
          </div>
        </section>
      </div>
    );
  };

  return (
    <DataFetcherTemplateHome url={url}>
      {(data) => <DataDisplay data={data} />}
    </DataFetcherTemplateHome>
  );
}

export default SistemaAcademico;